import { render, staticRenderFns } from "./finishedVisit.vue?vue&type=template&id=54972ac9&scoped=true&"
import script from "./finishedVisit.vue?vue&type=script&lang=js&"
export * from "./finishedVisit.vue?vue&type=script&lang=js&"
import style0 from "./finishedVisit.vue?vue&type=style&index=0&id=54972ac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54972ac9",
  null
  
)

export default component.exports